var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1626 13.2066C11.9424 10.1093 14.7367 7.39922 16.0364 6.43133C20.3257 4.49554 22.3723 7.56053 22.8594 9.33505C23.0218 11.7548 21.9821 17.5621 16.5234 21.4337C9.70003 26.2731 2.38969 20.9498 1.41492 19.9819C0.440154 19.014 -1.022 16.1103 3.36446 17.5621C7.75091 19.014 10.1878 17.0782 11.1626 13.2066Z",
    fill: "url(#paint0_linear_11113_58833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3605 7.83284C17.1047 7.57701 15.5129 7.12221 14.8022 7.08668L15.3352 6.55371L20.5583 6.6603L23.5429 8.57899C23.7206 9.00537 23.9053 9.87944 23.2232 9.96471C22.3704 10.0713 21.1978 9.32515 20.9846 8.89877C20.7714 8.4724 20.4518 8.89877 19.2791 9.00537C18.1066 9.11196 17.6803 8.15262 17.3605 7.83284Z",
    fill: "#1C2A34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9329 4.38431C21.0713 3.28324 20.9865 1.87008 20.4261 1.13402C19.6723 0.143469 17.4197 0.621668 18.0046 1.20971C18.6559 1.86539 19.6703 2.71931 19.6335 3.98983C19.6037 3.98314 19.5759 3.97509 19.5454 3.9684C16.9292 3.38638 14.9854 4.90939 14.6828 5.94951C14.1522 7.77257 17.4407 6.32993 17.858 7.12961C19.0928 9.49382 20.5061 7.23341 20.8453 7.98688C21.1845 8.74035 23.625 10.8688 23.625 8.41285C23.625 6.3969 22.8163 5.12906 20.9329 4.38431Z",
    fill: "url(#paint1_linear_11113_58833)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11113_58833",
    x1: 9.22847,
    y1: 10.7978,
    x2: 18.8792,
    y2: 21.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FF1744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#B20500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11113_58833",
    x1: 14.1847,
    y1: 3.94485,
    x2: 24.4899,
    y2: 11.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A0BD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#7F972D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#52650B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicy);
export default __webpack_public_path__ + "static/media/SPICY.c26aa86d77a58e11b8fae8d5dd9acffe.svg";
export { ForwardRef as ReactComponent };